import { Size as ScreenSize } from '@ps/web-core-enums';
import { useScreenSize } from '@ps/web-shared-components';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { type Dispatch, select } from '@swf/core/store';

/**
 * Automatically sets the context for betSlip open to true if the receipt is rendered on mobile
 * after placing a bet
 */
const useOpenReceiptOnMobile = () => {
  const { betSlip } = useDispatch<Dispatch>();
  const isBetReceiptActive = useSelector(select.betSlip.isBetReceiptActive);
  const { greaterThan } = useScreenSize();
  const isMobile = !greaterThan(ScreenSize.Small);

  useEffect(() => {
    if (isMobile && isBetReceiptActive) betSlip.betSlipOpened(true);
  }, [isMobile, betSlip, isBetReceiptActive]);
};

export default useOpenReceiptOnMobile;
